import React from 'react'

import loadMoreButton from '../../styles/components/homePage/load_more_button'
import { Spinner } from '../Spinner'

const LoadMoreButton = ({ loadMore, loading, byline = null }) => (
  <div data-testid='load-more' className='load-more-button'>
    {!loading ? (
      <button
        data-testid='load-more-button'
        onClick={() => {
          loadMore()
          self.COMSCORE && COMSCORE.beacon({ c1: '2', c2: '34363161' })
        }}>
        More Stories{byline ? ` by ${byline}` : null}
      </button>
    ) : (
      <Spinner />
    )}
    <style jsx>{loadMoreButton}</style>
  </div>
)

export default LoadMoreButton
